import { Component, Input, OnInit } from '@angular/core';
import { AssetFile, IPagedList } from '@brafton/assets-api';
import { IBase } from '@brafton/common-framework-library';
import { ProjectHelper } from 'src/app/core/utils/project.helper';

@Component({
  selector: 'content-listing-wrapper',
  templateUrl: './content-listing-list-wrapper.component.html',
  styleUrls: ['./content-listing-list-wrapper.component.scss'],
})
export class ContentListingWrapperComponent implements OnInit {
  @Input() projects?: IPagedList<IBase>;

  constructor(private projectHelper: ProjectHelper) { }

  ngOnInit(): void {
    this.projects
  }

  pullDefaultAssetFile(projects: any): AssetFile | undefined {
    if (!projects || !projects.defaultAsset) return undefined;

    const file = projects.defaultAsset.assetFiles?.find(
      (af: any) => af.status.id == 'Ready' && af.accessLevel.id == 'Public',
    );

    return file;
  }

  getLastActiveDate(project: any): Date | undefined {
    if (!project) return;
    const head = this.projectHelper.findProject(project);
    return head?.lastUpdated || this.projectHelper.getProjectDueDate(head);
  }

  getDueDate(project: IBase): any {
    this.projectHelper.getProjectDueDate(project);
  }
}
